module.exports = __webpack_public_path__ + "img/premiation-6-tv-55.c2d292d4.png";